class SimpleSelect {
    constructor(select) {
        this.container = $('<div class="select"/>');
        this.select = $(select).wrap(this.container);
        this.value = $('<div class="select-value"/>').appendTo(this.container);
        if (this.select.attr('placeholder'))
            this.value.attr('data-placeholder', this.select.attr('placeholder'));
        if (this.select.attr('data-icon'))
            this.container.attr('data-icon', this.select.attr('data-icon'));
        this.select.on('focus', $.proxy(this.onFocus, this));
        this.select.on('blur', $.proxy(this.onBlur, this));
        this.select.on('change', $.proxy(this.onChange, this));
        this.onChange();
    }
    onFocus() {
        this.container.addClass('focus');
    }
    onBlur() {
        this.container.removeClass('focus');
    }
    onChange() {
        var selected = $(this.select[0].options[this.select[0].selectedIndex]);
        this.value.text(selected.text());
    }
}

// jQuery helper

$.fn.simpleSelect = function() {
    this.each(function(){
        new SimpleSelect(this);
    });
}
